import { useState } from "react";

export interface QuizAnswer {
  questionId: string;
  selectedAnswer: {
    en: string;
    am: string;
  };
  isCorrect: boolean;
}

export interface QuizResult {
  success: boolean;
  score?: number;
  percentage?: number;
  totalQuestions?: number;
  feedback?: string;
  error?: string;
}

export interface QuizProgress {
  tutorialProgress?: number;
  courseProgress?: number;
}

/**
 * Custom hook for managing quiz visibility and basic state
 */
export const useQuizVisibility = () => {
  const [showQuiz, setShowQuiz] = useState(false);
  const [quiz, setQuiz] = useState<any>(null);
  const [quizError, setQuizError] = useState<string>("");

  return {
    showQuiz,
    setShowQuiz,
    quiz,
    setQuiz,
    quizError,
    setQuizError,
  };
};

/**
 * Custom hook for managing quiz answers and results
 */
export const useQuizAnswers = () => {
  const [quizAnswers, setQuizAnswers] = useState<QuizAnswer[]>([]);
  const [quizResult, setQuizResult] = useState<QuizResult | null>(null);
  const [isSubmittingQuiz, setIsSubmittingQuiz] = useState(false);

  return {
    quizAnswers,
    setQuizAnswers,
    quizResult,
    setQuizResult,
    isSubmittingQuiz,
    setIsSubmittingQuiz,
  };
};

/**
 * Custom hook for managing quiz progress and navigation
 */
export const useQuizProgress = () => {
  const [progress, setProgress] = useState<QuizProgress | null>(null);
  const [currentQuizQuestionIdx, setCurrentQuizQuestionIdx] = useState(0);
  const [quizStartTime, setQuizStartTime] = useState<number | null>(null);

  return {
    progress,
    setProgress,
    currentQuizQuestionIdx,
    setCurrentQuizQuestionIdx,
    quizStartTime,
    setQuizStartTime,
  };
};
